import { useTranslation } from 'react-i18next'
import { EarnMyAsset, EarnMyAssets } from './EarnMyAssets'

export interface EarnNoPortfolioProps {
  assets: EarnMyAsset[]
  showCustomerEarnRate?: boolean
}

export const EarnNoPortfolio = ({ assets, showCustomerEarnRate = true }: EarnNoPortfolioProps) => {
  const { t } = useTranslation()

  return (
    <EarnMyAssets
      assets={assets}
      showCustomerEarnRate={showCustomerEarnRate}
      title={t('earn.noPortfolioState.title')}
      availableColumnLabel={t('earn.availableInWalletsColumn')}
      myEarnRateColumnLabel={t('earn.earnRateColumn')}
      depositOnly
    />
  )
}
